import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { FormsModule } from '@angular/forms';
import { SVGIcon, filterIcon } from '@progress/kendo-svg-icons';

export interface TimeRange {
  text: string;
  value: string;
}

@Component({
  selector: 'app-filter-header',
  templateUrl: './filter-header.component.html',
  styleUrls: ['./filter-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, DropDownsModule, DatePickerModule, ButtonsModule, FormsModule],
})
export class FilterHeaderComponent {
  timeRanges = input.required<TimeRange[]>();
  selectedTimeRange = input.required<TimeRange>();
  startDate = input<Date | null>(null);
  endDate = input<Date | null>(null);

  onTimeRangeChange = output<TimeRange>();
  onStartDateChange = output<Date | null>();
  onEndDateChange = output<Date | null>();
  onApplyFilters = output<void>();

  protected readonly filterIcon = filterIcon;
}
